export default __webpack_public_path__ + "static/media/021-pad thai.015f0233.svg";